import http from "@/assets/js/common/http-common";

class DesempenhoDataService {
  dashboard(params = {}) {
    return http.get("desempenho/dashboard", { params });
  }

  status() {
    return http.get("desempenho/status");
  }
}

export default new DesempenhoDataService();
